























import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_currentUnitProductVariantHolders_currentUnit_productVariantHolders } from '@/queries/__generated__/currentUnitProductVariantHolders';
import gql from 'graphql-tag';

const DELETE_PRODUCT_VARIANT_HOLDER = gql`
  mutation deleteProductVariantHolder($id: ID!) {
    deleteProductVariantHolder(
      input: {
        id: $id,
      }
    ) {
      productVariantHolder {
        id
      }
    }
  }
`;

@Component
export default class HolderDeleteButton extends Vue {
  @Prop() private productVariantHolder!: GQL_currentUnitProductVariantHolders_currentUnit_productVariantHolders;
  private DELETE_PRODUCT_VARIANT_HOLDER = DELETE_PRODUCT_VARIANT_HOLDER;

  private confirmDelete(confirmMutation: () => {}) {
    this.$sPopup.confirm('', {
      title: this.$t('PopupTitle.confirmDelete'),
      message: this.$t('PopupBody.confirmDelete', { thing: this.productVariantHolder.name }),
      onConfirm: confirmMutation,
    });
  }
}
